import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CultivatingCommunity from "./sections/CultivatingCommunity";
import TheHarvestGallery from "./sections/TheHarvestGallery";
import GardenLifeCulture from "./sections/GardenLifeCulture";
import OurImpactInNumbers from "./sections/OurImpactInNumbers";
import SeasonalPlantingGuide from "./sections/SeasonalPlantingGuide";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CultivatingCommunity />
      <TheHarvestGallery />
      <GardenLifeCulture />
      <OurImpactInNumbers />
      <SeasonalPlantingGuide />
      <Footer />
    </div>;
}